import React, { useEffect, useState } from 'react';
import { Loader, Modal, Dimmer, Icon } from 'semantic-ui-react';
import { SelectableModalProps } from '../../../../../components/types';
import styled from 'styled-components';
import FollowUpTab from '../Tabs/FollowUpTab';
import ActionHistoryTab from '../Tabs/ActionHistoryTab';

const CLAIM_UPDATES_ACCENT_COLOR = '#59249B';

const StyledModal = styled(Modal)`
  &&& {
    display: flex !important;
    flex-direction: column;
    max-height: calc(100vh - 32px);
  }

  &&& > .header {
    flex: 0 0 auto;
    color: #2f3441;
    border-bottom: 1px solid #e5e7eb;
  }

  &&& > .header i.icon {
    color: ${CLAIM_UPDATES_ACCENT_COLOR};
  }

  &&& > .content {
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  &&& > .actions {
    flex: 0 0 auto;
  }
`;

const TabsSection = styled.div`
  border-bottom: 1px solid #e5e7eb;
  margin: 0 -1.5rem 22px;
  padding: 0 1.5rem 20px;
`;

const TabContainer = styled.div`
  border: 1px solid #dddddd;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  width: 224px;
`;

const TabMenu = styled.div<{ actived: boolean }>`
  width: 50%;
  padding: 8px 10px;
  background-color: ${props => (props.actived ? CLAIM_UPDATES_ACCENT_COLOR : '#ffffff')};
  color: ${props => (props.actived ? '#ffffff' : CLAIM_UPDATES_ACCENT_COLOR)};
  cursor: ${props => (props.actived ? '' : 'pointer')};
  font-weight: ${props => (props.actived ? 700 : 400)};
  text-align: center;
`;

export type FollowUpModalProps = {
  onClose: () => any;
  onOpen: () => any;
  id: string;
  claim: any;
  isBlocked?: boolean;
  user: any;
} & SelectableModalProps;

type TabeProps = 'follow-up' | 'action-history';

const ClaimUpdatesListModal = (props: FollowUpModalProps) => {
  const { header, onClose, onOpen, isOpen, id, claim, user, isBlocked } = props; // , setUnread, unread
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tabActive, setTabActive] = useState<TabeProps>('follow-up');

  const hasActionHistoryPermission = !user.role.includes('ESTATE');

  const handleDisplay = (hasPermission: boolean) => {
    const classFirstTab = {
      borderRight: '1px solid #dddddd',
      borderTopLeftRadius: '4px',
      borderBottomLeftRadius: '4px'
    };
    const classLastTab = {
      borderTopRightRadius: '4px',
      borderBottomRightRadius: '4px'
    };
    const classTabActive = { backgroundColor: CLAIM_UPDATES_ACCENT_COLOR, color: '#FFFFFF' };
    const classTabInactive = { cursor: 'pointer' };

    const classTabFollowup =
      tabActive === 'follow-up'
        ? Object.assign({}, classFirstTab, classTabActive)
        : Object.assign({}, classFirstTab, classTabInactive);
    const classTabHistory =
      tabActive === 'action-history'
        ? Object.assign({}, classLastTab, classTabActive)
        : Object.assign({}, classLastTab, classTabInactive);

    return hasPermission ? (
      <>
        <TabsSection>
          <TabContainer>
            <TabMenu
              actived={tabActive === 'follow-up'}
              style={classTabFollowup}
              onClick={() => setTabActive('follow-up')}
            >
              Geral
            </TabMenu>
            <TabMenu
              actived={tabActive === 'action-history'}
              style={classTabHistory}
              onClick={() => setTabActive('action-history')}
            >
              Histórico
            </TabMenu>
          </TabContainer>
        </TabsSection>

        {tabActive === 'follow-up' ? (
          <FollowUpTab id={id} claim={claim} isBlocked={isBlocked} />
        ) : tabActive === 'action-history' ? (
          <ActionHistoryTab id={id} />
        ) : null}
      </>
    ) : (
      <FollowUpTab id={id} claim={claim} isBlocked={isBlocked} />
    );
  };

  return (
    <>
      <StyledModal size="large" open={isOpen} onOpen={onOpen} onClose={onClose} closeIcon>
        <Modal.Header>
          {hasActionHistoryPermission ? (
            <>
              <Icon name={tabActive === 'follow-up' ? 'shield alternate' : 'history'} />{' '}
            </>
          ) : null}
          {header}
        </Modal.Header>
        <Modal.Content>
          {isLoading ? (
            <Dimmer active={isLoading} inverted>
              <Loader content="Carregando mensagens..." />
            </Dimmer>
          ) : (
            handleDisplay(hasActionHistoryPermission)
          )}
        </Modal.Content>
        <Modal.Actions></Modal.Actions>
      </StyledModal>
    </>
  );
};

export default ClaimUpdatesListModal;
